export const API_URL = "https://api.woodandwashi.ru";
export const AUTH_URL = "https://services.woodandwashi.ru/nav";
